export function sort({ specificities, characteristicType })
{
	return specificities.sort((a, b) =>
	{
		const sortA = getSortAtSpecificityType(a.specificityType, characteristicType);
		const sortB = getSortAtSpecificityType(b.specificityType, characteristicType);

		return sortA === sortB
			? a.specificity.label.localeCompare(b.specificity.label)
			: (sortA > sortB ? -1 : 1);
	});
}

function getSortAtSpecificityType (specificityType, characteristicType)
{
	const item = _.find(
		characteristicType.specificityTypes,
			allocation => allocation.specificityType.id === specificityType.id
	);

	return item?.sort;
}
